<div class="input-cell">
    <div class="label-value-input">
        <div class="input-label">Title</div>
        <div class="input-value">{{item?.title}}</div>
    </div>
    <!-- <div class="label-value-input">
        <div class="input-label">
            <nb-icon [ngClass]="isSelected ? 'active': 'inactive'"  class="enabled" icon="navigation-2-outline" pack="eva" title="Select" (click)="selectItem(contentId)"></nb-icon>
        </div>
        <div class="input-value upper">{{contentId}}</div>
    </div>
    <nb-actions class="actions" size="tiny">
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'" icon="edit-outline" pack="eva" (click)="editItem(contentId)" title="Edit Section"></nb-icon>
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="grid-outline" pack="eva" title="Edit Cells" (click)="editChildren(contentId)"></nb-icon>
        </nb-action>
        <nb-action>
            <ng-container *ngIf="shown;else show">
                <nb-icon class="enabled" icon="eye-off-outline" pack="eva" title="Hide" (click)="toggleShow(contentId)"></nb-icon>
            </ng-container>
            <ng-template #show>
                <nb-icon class="enabled"  icon="eye-outline" pack="eva" title="show" (click)="toggleShow(contentId)"></nb-icon>
            </ng-template>
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'" icon="trash-2-outline" pack="eva" title="Delete" (click)="deleteItem(contentId)"></nb-icon>
        </nb-action>
        
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="arrow-circle-up-outline" pack="eva" title="Order Up" (click)="upItem(contentId)"></nb-icon>
        </nb-action>
        <nb-action>
            <nb-icon [ngClass]="isSelected ? 'enabled': 'disabled'"  icon="arrow-circle-down-outline" pack="eva" title="Order Down" (click)="downItem(contentId)"></nb-icon>
        </nb-action>
    </nb-actions> -->
    <p>Block commented out cause an error nb-icon not a knoen element</p>
</div>




